<nav class="navbar navbar-light sticky-top navbar-expand-md" id="nav" *ngIf="showNav">
  <div class="container px-0 max-width-wrapper mx-auto">
    <a class="navbar-brand" routerLink="/">
      <img src="./assets/sos-logo.svg" class="logo" width="82px" height="52px">
    </a>
    <button class="navbar-toggler d-block d-md-none" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fas fa-lg"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarScroll">
      <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 150px;">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="/">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">My Shows</a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link active">
            <!-- <img src="../../../images/icons/search-icon.svg" width="20px"
              height="20px" alt="search icon"> -->
            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="27" height="27.007" viewBox="0 0 27 27.007">
              <path
                d="M31.184,29.545l-7.509-7.58a10.7,10.7,0,1,0-1.624,1.645l7.46,7.53a1.156,1.156,0,0,0,1.631.042A1.163,1.163,0,0,0,31.184,29.545ZM15.265,23.7a8.45,8.45,0,1,1,5.977-2.475A8.4,8.4,0,0,1,15.265,23.7Z"
                transform="translate(-4.5 -4.493)" fill="#fff" />
            </svg>
          </a>
        </li>
      </ul>
      <form class="d-flex">
        <button type="button" class="btn btn-link" routerLink="/login" *ngIf="!user">Login</button>
        <button class="btn btn-sos-main" type="submit" routerLink="/signup" *ngIf="!user">Sign Up</button>
        <div class="dropdown" *ngIf="user">
          <button type="button" class="btn btn-link d-flex align-items-center pe-0" data-bs-toggle="dropdown"
            aria-expanded="false">{{ user?.username
            }}
            <i class="far fa-user-circle fa-2x user-icon" *ngIf="user && !user?.profile?.avatar"></i>
            <img [src]="user?.profile?.avatar?.url" class="avatar" id="image" *ngIf="user?.profile?.avatar">
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><a class="dropdown-item" routerLink="/account/profile/my-profile">My Profile</a></li>
            <li><a class="dropdown-item" routerLink="/support">Support</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
          </ul>
        </div>
        <!-- <i class="far fa-user-circle fa-2x user-icon" *ngIf="user && !user?.profile?.avatar"></i>
          <img [src]="user?.profile?.avatar?.url" class="avatar" id="image" *ngIf="user?.profile?.avatar"> -->
      </form>
    </div>
  </div>
</nav>